import { cloneElement } from "react";
export function FormItemAntDChangeInBlur({
    value,
    onChange,
    children
}:any) {
    return cloneElement(children, {
        onBlur : onChange,
        value : value
    });
}

export default {
    FormItemAntDChangeInBlur
}